import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "./_helpers";

import { LoginComponent } from "./login/login.component";
import { HomeComponent } from "./home/home.component";
import { LocationsComponent } from "./locations/locations.component";
import { EmployeesComponent } from "./employees/employees.component";
import { AssetsComponent } from "./assets/assets.component";
import { ErrorPageComponent } from "./error-page/error-page.component";
import { InventoryComponent } from "./inventory/inventory.component";
import { AdminAuthGuard } from "./_helpers/admin.auth.guard";
import { UserListComponent } from "./users/users-list.component";
import { InventoryListComponent } from "./inventory-list/inventory-list.component";
import { InventoryCreateComponent } from "./inventory-create/inventory-create.component";
import { AdminPageComponent } from "./admin-page/admin-page.component";
import { FoundAssetsComponent } from "./found-assets/found-assets.component";
import { SuppliersComponent } from "./suppliers/suppliers.component";
import { DiscardRecommendationsComponent } from "./discard-recommendations/discard-recommendations.component";
import { LegalEntitiesComponent } from "./legal-entities/legal-entities.component";
import { DepartmentsComponent } from "./departments/departments.component";
import { NoAccessPageComponent } from "./no-access-page/no-access-page.component";
import { NotFoundPageComponent } from "./not-found-page/not-found-page.component";

const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "/assets" },
  { path: "home", component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: "suppliers",
    component: SuppliersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "legal-entities",
    component: LegalEntitiesComponent,
    canActivate: [AdminAuthGuard],
  },
  {
    path: "departments",
    component: DepartmentsComponent,
    canActivate: [AuthGuard],
  },
  { path: "assets", component: AssetsComponent, canActivate: [AuthGuard] },
  {
    path: "assets/:legalEntityId",
    component: AssetsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "locations",
    component: LocationsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "employees",
    component: EmployeesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "suppliers",
    component: SuppliersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "users",
    component: UserListComponent,
    canActivate: [AdminAuthGuard],
  },
  {
    path: "inventory-list",
    component: InventoryListComponent,
    canActivate: [AdminAuthGuard],
  },
  {
    path: "create-inventory",
    component: InventoryCreateComponent,
    canActivate: [AdminAuthGuard],
  },
  {
    path: "admin-page",
    component: AdminPageComponent,
    canActivate: [AdminAuthGuard],
  },
  {
    path: "inventory/:id",
    component: InventoryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "found-assets",
    component: FoundAssetsComponent,
    canActivate: [AdminAuthGuard],
  },
  {
    path: "discard-proposals",
    component: DiscardRecommendationsComponent,
    canActivate: [AdminAuthGuard],
  },
  { path: "error", component: ErrorPageComponent },
  { path: "no-access", component: NoAccessPageComponent },
  { path: "not-found", component: NotFoundPageComponent },
  { path: "login", component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
